const heroSection = () => {
    const elements = document.querySelectorAll(".hero__el");
    const texts = document.querySelectorAll(".hero__title h2");
    const navbar = document.querySelector(".navbar");

    // Navbar scroll behaviour sempre attivo
    if (navbar) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                navbar.classList.add("scrolled");
            } else {
                navbar.classList.remove("scrolled");
            }
        });
    }

    // Se non siamo nella hero usciamo
    if (!elements.length || texts.length < 2) return;

    let scrollTriggerConfig = {
        scrollTrigger: {
            trigger: ".hero__section",
            start: "top top",
            end: "+=2000",
            scrub: 1.2,
            pin: true
        },
        onLeave: () => navbar?.classList.add("scrolled"),
        onEnterBack: () => navbar?.classList.remove("scrolled")
    };

    const tl = gsap.timeline(scrollTriggerConfig);

    tl.to(elements[0], {
        rotation: 720,
        ease: "none"
    }, 0)

    .to(elements[1], {
        rotation: -720,
        ease: "none"
    }, 0);

    tl.add("changeText", 0.1)

    .to(texts[0], {
        y: "-50% + 60px",
        opacity: 0,
        duration: 0.3
    }, "changeText")

    .to(texts[1], {
        y: 0,
        opacity: 1,
        duration: 0.3
    }, "changeText+0.4");
};

export default heroSection;